export default __webpack_public_path__ + "static/media/File No. 15.f22fb2f8.pdf";